import uuidV4 from 'uuid/v4';
import StorageUtils from '@spothero/utils/storage';

const SESSION_UUID_COOKIE = 'sh-session-uuid';
const SEARCH_UUID_COOKIE = 'sh-search-uuid';
const ACTION_UUID_COOKIE = 'sh-action-uuid';
const ACTION_COOKIE = 'sh-action-id';
const HALF_HOUR_IN_DAYS = 0.021;

/**
 * Utility for tracking user search behavior.
 * @module SearchTracking
 */
const SearchTracking = {
    updateAction(actionName = 'SEARCH') {
        StorageUtils.remove(ACTION_UUID_COOKIE, 'cookie');

        if (
            /SEARCH|EVENT|DATE_CHANGED|FIND_ME|LIST_SEARCH|LIST_EVENT|LIST_DATE_CHANGED/.test(
                actionName
            )
        ) {
            StorageUtils.remove(SEARCH_UUID_COOKIE, 'cookie');
        }

        StorageUtils.set(
            ACTION_COOKIE,
            actionName,
            'cookie',
            HALF_HOUR_IN_DAYS
        );
    },

    getValues() {
        const sessionUUIDCookie = StorageUtils.get(
            SESSION_UUID_COOKIE,
            'cookie'
        );
        const searchUUIDCookie = StorageUtils.get(SEARCH_UUID_COOKIE, 'cookie');
        const actionUUIDCookie = StorageUtils.get(ACTION_UUID_COOKIE, 'cookie');
        const actionCookie = StorageUtils.get(ACTION_COOKIE, 'cookie');
        const sessionUUID = sessionUUIDCookie ? sessionUUIDCookie : uuidV4();
        const searchUUID =
            sessionUUIDCookie && searchUUIDCookie && /\S/.test(searchUUIDCookie) // cookie is not empty and not just whitespace
                ? searchUUIDCookie
                : uuidV4();
        const actionUUID =
            sessionUUIDCookie && searchUUIDCookie && actionUUIDCookie
                ? actionUUIDCookie
                : uuidV4();
        const action = actionCookie ? actionCookie : 'SEARCH';

        StorageUtils.set(
            SESSION_UUID_COOKIE,
            sessionUUID,
            'cookie',
            HALF_HOUR_IN_DAYS
        );
        StorageUtils.set(
            SEARCH_UUID_COOKIE,
            searchUUID,
            'cookie',
            HALF_HOUR_IN_DAYS
        );
        StorageUtils.set(
            ACTION_UUID_COOKIE,
            actionUUID,
            'cookie',
            HALF_HOUR_IN_DAYS
        );
        StorageUtils.set(ACTION_COOKIE, action, 'cookie', HALF_HOUR_IN_DAYS);

        return {
            sessionUUID,
            searchUUID,
            actionUUID,
            action,
        };
    },

    destroySession() {
        StorageUtils.remove(SESSION_UUID_COOKIE, 'cookie');
        StorageUtils.remove(SEARCH_UUID_COOKIE, 'cookie');
    },
};

export default SearchTracking;
